<div class="filter-tray">
    <div class="tray-items" [formGroup]="byStatusForm">
        <div formArrayName="statuses">
            <div class="tray-row" *ngFor="let statusCtrl of statuses.controls; let i = index">
                <single-choice
                    [formControl]="statusCtrl"
                    (click)="setEditingIndex(i)"
                    [completedUrl]="completionUrl"
                    [topic]="'status'"
                    [editMode]="true"
                    [ticketId]="fakeId"
                    [icon]="'check_circle'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="statusLabelerByService"
                    [choiceObserver]="statusObserver">
                </single-choice>
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="statuses.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addStatusField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="statusFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
